import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { trackEvent } from '@/lib/analytics';
import { withInlineLinks } from '@/lib/inlineLinks';

export function Overline({ children, dark = false, className = '' }) {
  return (
    <span className={`overline-tag ${dark ? 'text-steel-light' : 'text-steel'} ${className}`}>
      <span className={`h-px w-8 ${dark ? 'bg-steel-light' : 'bg-steel'}`} aria-hidden="true" />
      {children}
    </span>
  );
}

export function SectionHead({ overline, title, text, dark = false, className = '' }) {
  return (
    <div className={`max-w-3xl ${className}`}>
      {overline && <Overline dark={dark}>{overline}</Overline>}
      <h2 className={`mt-4 text-4xl sm:text-5xl tracking-tight leading-[1.05] font-medium ${dark ? 'text-bone' : 'text-navy'}`}>
        {title}
      </h2>
      {text && (
        <p className={`mt-5 text-lg leading-relaxed ${dark ? 'text-silver' : 'text-navy/65'}`}>
          {withInlineLinks(text, dark ? 'font-bold text-steel-light underline underline-offset-4 hover:text-bone transition-colors' : undefined)}
        </p>
      )}
    </div>
  );
}

export function CTALink({ to, event, eventParams, children, variant = 'primary', className = '', testid }) {
  const styles = {
    primary: 'btn-primary',
    accent: 'btn-accent',
    ghostLight: 'btn-ghost-light',
    ghostDark: 'btn-ghost-dark',
  };
  return (
    <Link
      to={to}
      data-testid={testid}
      onClick={() => event && trackEvent(event, eventParams)}
      className={`${styles[variant]} group ${className}`}
    >
      {children}
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </Link>
  );
}

export function ImageFrame({ src, alt, ratio = 'aspect-[4/3]', className = '', eager = false }) {
  return (
    <div className={`overflow-hidden rounded-md ${ratio} ${className}`}>
      <img
        src={src}
        alt={alt}
        loading={eager ? 'eager' : 'lazy'}
        decoding="async"
        className="h-full w-full object-cover transition-transform duration-700 ease-out-expo hover:scale-[1.03]"
      />
    </div>
  );
}
